import { CacheableDataObject } from 'models/CacheableDataObject';


class MatchSearchNotifications {

	constructor() {
		this.notifications = {};
	}

	allNotifications() {
		const flattened = _.flattenDeep(this.notifications);
		console.log('flattened', flattened);
		return flattened;
	}

	updateAll(searchNotifications) {
		this.notifications = {};
		for(let notification of searchNotifications) {
			notification = MatchSearchNotification.make(notification);
			this.setNotification(notification);
		}
	}


	setNotification(options, setTo) {
		const notification = MatchSearchNotification.make(options);
		if(setTo !== undefined) {
			notification.active = setTo ? 1 : 0;
		}
		_.setWith(this.notifications, MatchSearchNotifications.createPathFromMatch(options), notification, Object);
	}

	static createPathFromMatch(match) {
		let ranked = match.ranked;
		if(ranked === undefined) {
			ranked = match.is_ranked ? 1 : 0;
		}
		return [match.ladder_id, match.team_size, ranked, match.match_count];
	}

	hasNotification(match) {
		const notification = _.get(this.notifications, MatchSearchNotifications.createPathFromMatch(match), MatchSearchNotification.make());
		return notification.isActive();
	}

	totalNotificationsSet() {
		let count = 0;
		_.each(this.notifications, (notificationGame) => {
			_.each(notificationGame, (notificationMatchType) => {
				_.each(notificationMatchType, (notificationSomeIndex) => {
					_.each(notificationSomeIndex, (matchSearchNotification) => {
						if(matchSearchNotification.active) {
							count++;
						}
					})
				})
			});
		});
		return count;
	}

	gamesWithNotificationsCount() {
		let count = new Set();
		_.each(this.notifications, (notificationGame) => {
			_.each(notificationGame, (notificationMatchType) => {
				count.add(notificationGame);
			});
		});
		return count.size;
	}

}

class MatchSearchNotification extends CacheableDataObject {


	static make(data = { active: MatchSearchNotification.ACTIVE_REMOVED }) {
		const notification = MatchSearchNotification.create();
		notification.update({
			ladder_id: data.ladder_id,
			ranked: data.ranked,
			team_size: data.team_size,
			match_count: data.match_count,
			active: data.active,
		});
		return notification;
	}

	isActive() {
		return this.active !== MatchSearchNotification.ACTIVE_REMOVED;
	}
}

MatchSearchNotification.prototype.dataLocationParsers = {
	ranked: (notification, data) => {
		notification.ranked = data.ranked ? 1 : 0
	}
};

MatchSearchNotification.ACTIVE_DEFAULT = 2;
MatchSearchNotification.ACTIVE_PLAYER_SET = 1;
MatchSearchNotification.ACTIVE_REMOVED = 0;


export { MatchSearchNotifications };